import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './BudgetLoading.Styles';

const headerLoadingConfig = [
  {
    left: setLoadingConfigObject('line', 1, 154, styles.firstLine),
    style: styles.headerFirstLine,
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.secondLine),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.thirdLine),
  },
];
const firstCardLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.firstCardCircle),
    main: [
      setLoadingConfigObject('square', 1, null, styles.firstCardFirstLine),
      setLoadingConfigObject('square', 1, null, styles.firstCardSecondLine),
    ],
  },
];
const secondCardLoadingConfig = theme => [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.firstCardCircle),
    main: [
      'column',
      setLoadingConfigObject('square', 1, null, styles.secondCardLine(120)),
      setLoadingConfigObject('square', 1, null, styles.secondCardLine(115)),
    ],
  },
  {
    main: setLoadingConfigObject('line', 1, null, styles.divider(theme)),
  },
  { ...firstCardLoadingConfig[0], style: styles.marginBottom(25) },
  firstCardLoadingConfig[0],
  {
    main: setLoadingConfigObject(
      'line',
      1,
      null,
      styles.divider(theme, { ...styles.marginTop(32), ...styles.marginBottom(12) }),
    ),
  },
  {
    left: setLoadingConfigObject('circle', 1, null, styles.firstCardCircle),
    main: setLoadingConfigObject('square', 1, null, styles.firstCardLine),
  },
];
const lastLineLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.lastLine),
  },
];

export {
  headerLoadingConfig,
  lastLineLoadingConfig,
  firstCardLoadingConfig,
  secondCardLoadingConfig,
};
